import React from "react";
import PropTypes from "prop-types";
import styles from "components/manage-categories/no-categories.scss";

export const NoItems = ({ name }) => (
  <div className={ styles.title }>
    <h2>You have no {name}.</h2>
  </div>
);

NoItems.propTypes = {
  name: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/common/no-items.jsx